import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { FunctionComponent } from 'react';

type PaypalLogoProps = {
    className?: string;
};

const PaypalLogo: FunctionComponent<PaypalLogoProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'paypal-logo'}
            x="0px"
            y="0px"
            viewBox="-153 234 90 33"
        >
            <path
                fill="#253B80"
                d="M-141.4 240.7h-6.8c-.5 0-.9.3-.9.8l-2.8 17.5c-.1.3.2.7.6.7h3.3c.5 0 .9-.3.9-.8l.7-4.7c.1-.5.5-.8.9-.8h2.2c4.5 0 7.1-2.2 7.8-6.5.3-1.9 0-3.4-.9-4.4-1-1.1-2.7-1.8-5-1.8zm.8 6.5c-.4 2.5-2.2 2.5-4.1 2.5h-1l.7-4.6c0-.3.3-.5.6-.5h.5c1.2 0 2.4 0 3 .7.3.4.4 1 .3 1.9z"
            />
            <path
                fill="#253B80"
                d="M-121 247.1h-3.3c-.3 0-.5.2-.6.5l-.1.9-.2-.3c-.7-1-2.3-1.4-3.9-1.4-3.6 0-6.7 2.7-7.3 6.6-.3 1.9.1 3.8 1.2 5 1 1.2 2.4 1.7 4.1 1.7 2.9 0 4.5-1.9 4.5-1.9l-.1.9c-.1.3.2.7.6.7h2.9c.5 0 .9-.3.9-.8l1.8-11.2c.1-.4-.1-.7-.5-.7zm-4.5 6.3c-.3 1.9-1.8 3.1-3.7 3.1-1 0-1.7-.3-2.2-.9-.5-.6-.7-1.4-.5-2.3.3-1.9 1.8-3.2 3.7-3.2.9 0 1.7.3 2.2.9.4.7.6 1.5.5 2.4z"
            />
            <path
                fill="#253B80"
                d="M-103.5 247.1h-3.3c-.3 0-.6.2-.8.4l-4.5 6.7-1.9-6.4c-.1-.4-.5-.7-.9-.7h-3.2c-.4 0-.7.4-.5.8l3.6 10.6-3.4 4.8c-.3.4 0 .9.5.9h3.3c.3 0 .6-.2.8-.4l10.9-15.8c.1-.4-.2-.9-.6-.9z"
            />
            <path
                fill="#179BD7"
                d="M-92.6 240.7h-6.8c-.5 0-.9.3-.9.8l-2.8 17.5c-.1.3.2.7.6.7h3.5c.3 0 .6-.2.7-.6l.8-5c.1-.5.5-.8.9-.8h2.2c4.5 0 7.1-2.2 7.8-6.5.3-1.9 0-3.4-.9-4.4-1.1-1-2.8-1.7-5.1-1.7zm.8 6.5c-.4 2.5-2.2 2.5-4.1 2.5h-1l.7-4.6c0-.3.3-.5.6-.5h.5c1.2 0 2.4 0 3 .7.3.4.4 1 .3 1.9z"
            />
            <path
                fill="#179BD7"
                d="M-72.2 247.1h-3.3c-.3 0-.5.2-.6.5l-.1.9-.2-.3c-.7-1-2.3-1.4-3.9-1.4-3.6 0-6.7 2.7-7.3 6.6-.3 1.9.1 3.8 1.2 5 1 1.2 2.4 1.7 4.1 1.7 2.9 0 4.5-1.9 4.5-1.9l-.1.9c-.1.3.2.7.6.7h2.9c.5 0 .9-.3.9-.8l1.8-11.2c.1-.4-.1-.7-.5-.7zm-4.6 6.3c-.3 1.9-1.8 3.1-3.7 3.1-.9 0-1.7-.3-2.2-.9-.5-.6-.7-1.4-.5-2.3.3-1.9 1.8-3.2 3.7-3.2.9 0 1.7.3 2.2.9.5.7.7 1.5.5 2.4z"
            />
            <path
                fill="#179BD7"
                d="M-68.3 241.2l-2.8 17.9c-.1.3.2.7.6.7h2.8c.5 0 .9-.3.9-.8l2.8-17.5c.1-.3-.2-.7-.6-.7h-3.2c-.2-.1-.5.2-.5.4z"
            />
        </svg>
    );
};

export default PaypalLogo;
